<template>

    <VehicleConfigurationNav v-if="!loading" @usage="setUsage" />

    <StepsToCalculateNav v-if="!loading" :fuelCost="costElectric" :equipment="costEquipment" :otherCost="costOther" :active="0" :usage="currentUsage" />

    <div class="container-fluid" v-if="!loading">
        <div class="row my-5">
            <div class="col-sm-6 vehicle-card-col">
                <VehicleCard :vehicle="vehicleInfo" />
            </div>
            <div class="col-sm-6 text-left vehicle-input-col">
                <p class="heading-3">Electric Cost Input</p>
                <div class="input-block">

                    <!-- Miles per year / Hours of Operation -->
                    <div class="form-group mt-5" v-if="currentUsage == 'miles'">
                        <label for="electricMileageYear" class="w-100">Mileage (miles/year)</label>
                        <input type="text" class="range-output output-text" v-model="milesPerYearFormatted" @input="formatInputMiles(); calculateAllSetup()" @change="trackMilesPerYear(milesPerYear)">
                        <input type="number" id="electricMileageYearOutput" class="range-output d-none" min="0" max="200000" v-model="milesPerYear">
                        
                        <input class="form-control-range" type="range" id="electricMileageYear" name="electricMileageYear" min="0" max="200000" v-model="milesPerYear" @input="formatInputFromSliderMiles(); calculateAllSetup()" @change="trackMilesPerYear(milesPerYear)"> 
                    </div>
                    <div class="form-group mt-5" v-if="currentUsage == 'hours'">
                        <label for="electricMileageYear" class="w-100">Operating Time (hours/year)</label>
                        <input type="text" class="range-output output-text" v-model="hoursPerYearFormatted" @input="formatInputHours(); calculateAllSetup()" @change="trackHoursPerYear(hoursPerYear)">
                        <input type="number" id="electricMileageYearOutput" class="range-output d-none" min="0" max="10000" v-model="hoursPerYear">

                        <input class="form-control-range" type="range" id="electricMileageYear" name="electricMileageYear" min="0" max="10000" v-model="hoursPerYear" @input="formatInputFromSliderHours(); calculateAllSetup()" @change="trackHoursPerYear(hoursPerYear)"> 
                    </div>

                    <!-- Electric Cost kWh -->
                    <div class="form-group mt-5">
                        <label for="electricFuelCostKwh">Electricity Costs ($/kWh)</label>
                        <input type="number" id="electricCostKwhOutput" class="range-output output-text" min="0" max="1" v-model="electricCost" @input="calculateAllSetup()" @change="convertValues(); trackElectricityCost(electricCost)">
                        <input class="form-control-range" type="range" id="electricCostKwh" name="electricCostKwh" min="0" max="0.3" v-model="electricCost" step="0.005" @input="convertValues(); calculateAllSetup()" @change="trackElectricityCost(electricCost)">
                    </div>
                    
                    <!-- fancy power bodies -->
                    <div v-if="this.hasVocationalBody" id="vocational-body" class="mx-auto"> 

                        <div class="dropdown border mt-5" @click="calculateAllSetup()">
                            <a class="dropdown-toggle text-center w-100" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="text-uppercase" id="vocation-select"><small>Will a vocational body use power from the electric chassis</small></span>
                            </a>
                             <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" id="none-tab" data-toggle="tab" href="#none" @click="clearActiveBody()">None</a>
                                <a class="dropdown-item" :class="[bodyPart.name == activeTab ? 'active' : '']" :id="index" data-toggle="tab" :href="'#tab'+index" v-for="(bodyPart, index) in this.bodyParts" :key="index" @click="activeClickClear('.dropdown-item', bodyPart)">{{ bodyPart.name }}</a>
                            </div>
                        </div>

                        <!-- TODO add into total Calculations -->
                        <transition name="fade">
                            <div class="body-inputs border border-top-none p-4" v-if="activeTab != 'none'" :key="activeBodyType.name">
                                <p class="heading-3 mb-3">{{ activeBodyType.name }}</p>
                                <!-- PTO power consumtion -->
                                <div class="form-group form-group-inline text-input-group mt-3 mb-0">
                                    <label for="vocationPowerConsumtion">PTO Power Consumption (kWh/Lift)</label>
                                    <input type="number" ref="powerConsumptionPerLift" id="vocationPowerConsumtion" class="range-output power-consumption" min="0" max="50" step=".001" v-model="activeBodyType.bodyPowerConsumption" @change="convertValues(); convertThis($event); calculateAllSetup(); trackPTOPowerConsumptionPerLift(activeBodyType.bodyPowerConsumption)">
                                </div>

                                <!-- Collections/lifts per day -->
                                <div class="form-group form-group-inline text-input-group mt-3 mb-0">
                                    <label for="collectionInput">{{ activeBodyType.bodyAction }}</label>
                                    <input type="number" id="collectionInput" class="range-output" min="0" max="1000" v-model="activeBodyType.collectionsPerDay" @input="calculateAllSetup(activeBodyType.collectionsPerDay)" @change="trackCollections(activeBodyType.collectionsPerDay)">
                                </div>

                                <!-- Operating Days -->
                                <div class="form-group my-3">
                                    <label for="ptoOperatingDays">Operating Days Per Year</label>
                                    <input type="number" id="ptoOperatingDaysOutput" class="range-output" min="0" max="366" v-model="PTOOperatingDays" @input="calculateAllSetup()">
                                    <input class="form-control-range" type="range" id="ptoOperatingDays" name="ptoOperatingDays" min="0" max="366" v-model="PTOOperatingDays" @input="calculateAllSetup()" @change="trackOperatingDays(PTOOperatingDays)">
                                </div>
                            </div>    
                        </transition>              
                    </div>
                    <div class="spanner mb-5 pt-5"></div>
                </div>

                <div class="text-center next-link position-relative">
                    <router-link to="/electric/equipment-costs" class="big-link heading-2 text-center" @click="trackNextCategory()">Next Step <img :src="`${imagePath}/arrow-white.png`" alt=""></router-link>
                </div>
            </div>
        </div>
    </div>

    <div class="container-footer" v-if="!loading">
        <div class="container-fluid">
            <div class="row py-4">
                <div class="col-sm-12">
                    <div class="totals-container d-flex w-100 justify-content-between">
                        <div class="totals-item">
                            <p class="text-uppercase">Electric Costs Total</p>
                            
                            <div class="d-flex justify-content-between">

                                <div class="mr-5" v-if="currentUsage == 'miles'">
                                    <p class="mb-0" id="costPerMileOuput" v-html="formatPrice(totalCostPerMile * currencyExchange)"></p>
                                    <small>Total Cost Per Mile</small>
                                </div>
                                <div class="mr-5" v-if="currentUsage == 'hours'">
                                    <p class="mb-0" id="costPerMileOuput" v-html="formatPrice(totalCostPerHour * currencyExchange)"></p>
                                    <small>Total Cost Per Hour</small>
                                </div>

                                <div class="" v-if="currentUsage == 'miles'">
                                    <p class="mb-0" id="annualFuelCostOuput" v-html="formatPrice(totalAnnualCost * currencyExchange, 0)"></p>
                                    <small>Total Annual Cost</small>
                                </div>
                                <div class="" v-if="currentUsage == 'hours'">
                                    <p class="mb-0" id="annualFuelCostOuput" v-html="formatPrice(totalAnnualCostHourly * currencyExchange, 0)"></p>
                                    <small>Total Annual Cost</small>
                                </div>

                            </div>
                        </div>
                        <ElectricFooter :fuelCost="costElectric" :equipmentCost="costEquipment" :otherCost="costOther" :usage="currentUsage" />

                        <ElectricSummaryModal :vehicle="vehicleInfo" :fuelCost="costElectric" :equipment="costEquipment" :otherCost="costOther" :usage="currentUsage" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import vehicleList from '../services/vehicleList'
    import StepsToCalculateNav from "@/components/StepsToCalculateNav.vue";
    import VehicleConfigurationNav from "@/components/VehicleConfigurationNav.vue";

    import VehicleCard from "../components/VehicleCard"
    import ElectricFooter from "../components/ElectricFooter"
    import ElectricSummaryModal from "../components/ElectricSummaryModal"
    import calculator from '../services/calculator'
    import $ from 'jquery'
    

    export default {
        name: 'ElectricFuelCosts',
        data() {
            return {
                vehicle: '',
                currentUsage: 'miles', // set as default
                vehicleInfo: {},
                PTOOperatingTime: 8,
                PTOOperatingDays: 250,
                activePowerConsumption: 0.05,
                electricPTOPowerConsumption: 0,
                totalAnnualCost: 0,
                totalCostPerMile: 0,
                bodyParts: {},
                collections: 0,
                activeBodyType: {},
                milesPerYear: 0,
                milesPerYearFormatted: 0,
                hoursPerYear: 0,
                hoursPerYearFormatted: 0,
                electricCost: 0,
                costTotals: [],
                costElectric: {},
                costEquipment: {},
                costOther: {},
                activeTab: 'none',
                loading: true,
                fuelCost: 0,
                currencyType: '',
                currencyExchange: 0,
                currencyConversion: 1,
                imagePath: process.env.VUE_APP_ASSET_LOCATION
            }
        },
        components: {
            VehicleCard,
            ElectricFooter,
            StepsToCalculateNav,
            VehicleConfigurationNav,
            ElectricSummaryModal
        },
        created() {

            // For deeplinking. Since we only have 3 vehicles, stamping them out like this is the most maintainable
            if (this.$route.params.vehicle) {
                if (this.$route.params.vehicle == '220ev' || this.$route.params.vehicle == '220') { this.vehicle = 'twoTwenty' }
                if (this.$route.params.vehicle == '520ev' || this.$route.params.vehicle == '520') { this.vehicle = 'fiveTwenty' }
                if (this.$route.params.vehicle == '579ev' || this.$route.params.vehicle == '579') { this.vehicle = 'fiveSeventyNine' }

                localStorage.setItem('calculatorVehicleElectric', JSON.stringify(vehicleList[this.vehicle]['electric']))
                localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(vehicleList[this.vehicle]['diesel']))
            }
            
        },
        mounted() {

            // Grab vehicle info from storage and begin filling in props
            // vehicleInfoHidden is for setting equivalent values for diesel and electric
            this.vehicleInfo = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
            this.vehicleInfoHidden = JSON.parse(localStorage.getItem('calculatorVehicleDiesel'))

            // Set currency
            this.currencyType = sessionStorage.getItem('currency')
            this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1
            this.currencyConversion = Number(localStorage.getItem('USDtoCAD'))

            // If US from CA
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'true') {
                this.electricCost = Number(this.vehicleInfo.fuel.electricityCost / this.currencyConversion)
            }

            // If CA from US
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'false') {
                this.electricCost = Number(this.vehicleInfo.fuel.electricityCost * this.currencyConversion)
            }

            if (sessionStorage.getItem('fromCanada') == null) {
                this.electricCost = this.vehicleInfo.fuel.electricityCost
            }
            

            this.milesPerYear = this.vehicleInfo.fuel.mileage
            this.milesPerYearFormatted = (this.milesPerYear).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.hoursPerYear = this.vehicleInfo.fuel.hours
            this.hoursPerYearFormatted = (this.hoursPerYear).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            
            this.electricPTOPowerConsumption = this.vehicleInfo.fuel.powerConsumption

            // checks for existing storage value or sets default
            let electricItems = JSON.parse(sessionStorage.getItem('electricFuelCost'))
            if (electricItems && electricItems['ptoOperatingDays'] != null) {
                this.PTOOperatingDays = electricItems['ptoOperatingDays']
            } else {
                this.PTOOperatingDays = 250
            }

            //PowerBody Variables
            if(Object.prototype.hasOwnProperty.call(this.vehicleInfo, 'bodyType')) {
                this.hasVocationalBody = true
                this.bodyAction = this.vehicleInfo.bodyType.bodyAction
                this.bodyParts = this.vehicleInfo.bodyType.bodyParts
            } else {
                this.hasVocationalBody = false
            }

            let electricBodyType = JSON.parse(sessionStorage.getItem('ElectricBodyType'))
            if (electricBodyType && Object.keys(electricBodyType).length > 0) {
                this.activeBodyType = JSON.parse(sessionStorage.getItem('ElectricBodyType'))
                this.collections = this.activeBodyType.collectionsPerDay
                this.activeTab = this.activeBodyType.name
            }else {
                this.activeTab = 'none'
            }
            
            this.currentCurrency = sessionStorage.getItem('currency')
            this.usToCa = 1.27
            this.gallonToLitre = 3.79
            this.milesToKm = 1.61

            // Tracking
            if (this.$route.params.vehicle) {
                console.log('if ', this.$route.params.vehicle);
                window.gtag('event', 'page_view', {
                    page_title: `Cost Calculator - Electric ${this.$route.params.vehicle}`,
                    page_location: `/electric/${this.$route.params.vehicle}`
                });
            }else {
                console.log('else ', this.$route.params.vehicle);
                window.gtag('event', 'page_view', {
                    page_title: 'Cost Calculator - Electric Fuel Cost',
                    page_location: '/electric/fuel-costs'
                });
            }

            // Dont put anything below this. Loading should always be last
            this.convertValues()
            this.calculateAllSetup()


            this.loading = false

            // anything #madlad
            setTimeout(() => {
                let powerInputs = document.querySelectorAll('.power-consumption')
                powerInputs.forEach(input => {
                    input.value = Number(input.value).toFixed(3)
                })
            }, 250)
        },

        watch: {
            milesPerYearFormatted: function(newValue) {
                const result = newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.milesPerYearFormatted = result)
            },
            hoursPerYearFormatted: function(newValue) {
                const result = newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.hoursPerYearFormatted = result)
            }
        },

        methods: {

            convertValues() {
                this.electricCost = Number(this.electricCost).toFixed(3)
            },
            convertThis(event) {
                event.target.value = Number(event.target.value).toFixed(3)
                this.activePowerConsumption = event.target.value
            },

            calculateAllSetup() {
                let globalElectric
                let globalDiesel = localStorage.getItem('calculatorVehicleDiesel')

                // This Block of variables allows values to persist after going back
                // or after changing from Diesel Electric & vice-versa
                this.vehicleInfo.fuel.mileage = this.milesPerYear
                this.vehicleInfoHidden.fuel.mileage = this.milesPerYear
                
                this.vehicleInfo.fuel.hours = this.hoursPerYear
                this.vehicleInfoHidden.fuel.hours = this.hoursPerYear

                this.vehicleInfo.fuel.electricityCost = this.electricCost
                this.vehicleInfo.fuel.powerConsumption = this.electricPTOPowerConsumption

                //PowerBody Variables
                if(Object.prototype.hasOwnProperty.call(this.vehicleInfo, 'bodyType')) {
                    this.vehicleInfo.bodyType.bodyAction = this.bodyAction
                    this.vehicleInfo.bodyType.bodyParts = this.bodyParts
                }

                // Set values from local inputs and then retrieve to use in calculations below
                localStorage.setItem('calculatorVehicleElectric', JSON.stringify(this.vehicleInfo))
                localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(this.vehicleInfoHidden))
                globalElectric = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
                globalDiesel = JSON.parse(localStorage.getItem('calculatorVehicleDiesel'))

                // Fuel
                // TODO Look into removing redundancy. Using calculateTotals here seems to break.
                var ptoTotal = 0
                for(var i = 0; i < this.bodyParts.length; i++) {
                    if($('#vocationalbody'+ i).is(":visible")) {
                        ptoTotal = $('#vocationalbody'+ i).text();
                    } 
                }

                


                // calculation from vocationalbody fields
                if(this.hasVocationalBody && $('#none').hasClass('active') ) {
                    ptoTotal = 0
                } else if(this.hasVocationalBody && !$('#none').hasClass('active')) {
                    ptoTotal = parseFloat(ptoTotal);
                }

                let bodyIndex = this.vehicleInfo.bodyType != undefined && Object.keys(this.activeBodyType).length > 0 ? this.activeBodyType.id : -1

                // If there is no powerConsumption input, use default from vehicle's fuel object (powerConsumption)
                let powerConsumption = this.electricPTOPowerConsumption == 0 ? Number(globalElectric.fuel.powerConsumption) : Number(this.electricPTOPowerConsumption)
                
                // If there is no vocational body selected or available, default to 0
                let bodyPowerConsumption = Object.keys(this.activeBodyType).length > 0 ? Number(this.activeBodyType.bodyPowerConsumption) : 0
                let collectionsPerDay = Object.keys(this.activeBodyType).length > 0 ? Number(this.activeBodyType.collectionsPerDay) : 0

                let annualCostOutput =  parseFloat(
                    // Vehicle calculations
                    (globalElectric.fuel.mileage * powerConsumption * globalElectric.fuel.electricityCost) + 
                    // Vocational Body calculations
                    (globalElectric.fuel.electricityCost * bodyPowerConsumption * collectionsPerDay * Number(this.PTOOperatingDays)) + ptoTotal )
                
                // break down annual cost by global mileage
                let costPerMileOutput = globalElectric.fuel.mileage == 0 ? 0 : parseFloat(annualCostOutput / globalElectric.fuel.mileage)

                let annualCostOutputHourly = globalElectric.fuel.hours == 0 ? 0 : parseFloat(
                    // Vehicle calculations
                    (globalElectric.fuel.hours * powerConsumption * globalElectric.fuel.electricityCost) + 
                    // Vocational Body calculations
                    (globalElectric.fuel.electricityCost * Number(bodyPowerConsumption) * collectionsPerDay * this.PTOOperatingDays) + ptoTotal)

                let costPerHourOutput = globalElectric.fuel.hours == 0 ? 0 : parseFloat(annualCostOutputHourly / this.hoursPerYear)

                


                // Set footer totals
                this.totalAnnualCost = (annualCostOutput).toFixed(2)
                this.totalCostPerMile = (costPerMileOutput).toFixed(2)
                this.totalAnnualCostHourly = (annualCostOutputHourly).toFixed(2)
                this.totalCostPerHour = (costPerHourOutput).toFixed(2)

                // Kick final calculations to storage so we can keep the value for use on later tabs.
                //TODO  In the future, we should leverage VueX for any sort of data management. Great in-app storage.
                sessionStorage.setItem('electricFuelCost', JSON.stringify({
                        'annual-cost': Number(this.totalAnnualCost), 
                        'cost-per-mile': Number(this.totalCostPerMile),
                        'annual-cost-hourly': Number(this.totalAnnualCostHourly), 
                        'cost-per-hour': Number(this.totalCostPerHour),
                        'mileage': Number(this.milesPerYear),
                        'hours': Number(this.hoursPerYear),
                        'powerConsumption': Number(powerConsumption),
                        'pto': Number((ptoTotal).toFixed(2)),
                        'ptoOperatingDays': Number(this.PTOOperatingDays),
                        'ptoOperatingTime': this.PTOOperatingTime,
                        'bodyIndex': bodyIndex,
                        'activeBodyType': this.activeBodyType
                    })
                )

                // Set storage item for vocational body type
                sessionStorage.setItem('ElectricBodyType', JSON.stringify(this.activeBodyType))

                this.costElectric = JSON.parse(sessionStorage.getItem('electricFuelCost'))

                this.fuelCost = annualCostOutput

                

                
                // Equipment
                let existingStorageEquipment = JSON.parse(sessionStorage.getItem('electricEquipmentCost'))
                
                let perCharger
                existingStorageEquipment != null ? perCharger = existingStorageEquipment['per-charger'] : perCharger = 1
                
                let rebate
                existingStorageEquipment != null ? rebate = existingStorageEquipment['rebate'] : rebate = 0
                
                let amortization
                existingStorageEquipment != null ? amortization = existingStorageEquipment['amortization'] : amortization = this.vehicleInfo['equipment']['amortization']

                // let totalEquipmentCosts =  ((Number(this.vehicleInfo['equipment']['tractorPrice']) - Number(this.vehicleInfo['equipment']['resaleValue'])) + (Number(this.vehicleInfo['equipment']['chargerPrice']) / perCharger) - rebate)  / Number(amortization)
                let totalEquipmentCosts =  parseFloat(((globalElectric.equipment.tractorPrice - globalElectric.equipment.resaleValue) + (globalElectric.equipment.chargerPrice / perCharger) - rebate)  / amortization)

                // let annualCostOutput =  parseFloat(
                //     // Vehicle calculations
                //     (globalElectric.fuel.mileage * powerConsumption * globalElectric.fuel.electricityCost) + 
                //     // Vocational Body calculations
                //     (globalElectric.fuel.electricityCost * bodyPowerConsumption * collectionsPerDay * Number(this.PTOOperatingDays)) + ptoTotal )

                let costPerMileOutputEquipment = Number(globalElectric.fuel.mileage) != 0 ? parseFloat(totalEquipmentCosts / globalElectric.fuel.mileage).toFixed(2) : 0
                let costPerHourOutputEquipment = parseFloat(totalEquipmentCosts / globalElectric.fuel.hours).toFixed(2)

                sessionStorage.setItem('electricEquipmentCost', JSON.stringify({
                    'annual-cost': Number(totalEquipmentCosts), 
                    'cost-per-mile': Number(costPerMileOutputEquipment),
                    'cost-per-hour': Number(costPerHourOutputEquipment),
                    'vehicle-price': Number(this.vehicleInfo['equipment']['tractorPrice']),                    
                    'resale': Number(this.vehicleInfo['equipment']['resaleValue']),
                    'charger-price': Number(this.vehicleInfo['equipment']['chargerPrice']),
                    'per-charger': perCharger,
                    'rebate': rebate,
                    'amortization': amortization,
                }))

                

                
                // Other
                let existingStorageOther = JSON.parse(sessionStorage.getItem('electricOtherCost'))
                let existingStorageOtherDiesel = JSON.parse(sessionStorage.getItem('dieselOtherCost'))
                
                let maintenanceCost
                let insuranceCost
                let taxesCost
                let tollsCost
                let driverCost
                let maintenanceCostHourly
                let insuranceCostHourly
                let taxesCostHourly
                let tollsCostHourly
                let driverCostHourly
                
                let maintenanceCostDiesel
                let insuranceCostDiesel
                let taxesCostDiesel
                let tollsCostDiesel
                let driverCostDiesel
                let maintenanceCostHourlyDiesel
                let insuranceCostHourlyDiesel
                let taxesCostHourlyDiesel
                let tollsCostHourlyDiesel
                let driverCostHourlyDiesel
                
                let modifiedDiesel = false
                let modifiedElectric = false

                // Set values based on storage item
                if (existingStorageOther != null && existingStorageOther.modified == true) {
                    maintenanceCost = Number(existingStorageOther['cost-maintenance'])
                    insuranceCost = Number(existingStorageOther['cost-insurance'])
                    taxesCost = Number(existingStorageOther['cost-taxes'])
                    tollsCost = Number(existingStorageOther['cost-tolls'])
                    driverCost = Number(existingStorageOther['cost-driver'])
                    maintenanceCostHourly = Number(existingStorageOther['cost-maintenance-hourly'])
                    insuranceCostHourly = Number(existingStorageOther['cost-insurance-hourly'])
                    taxesCostHourly = Number(existingStorageOther['cost-taxes-hourly'])
                    tollsCostHourly = Number(existingStorageOther['cost-tolls-hourly'])
                    driverCostHourly = Number(existingStorageOther['cost-driver-hourly'])
                    modifiedElectric = existingStorageOther.modified
                } else {
                    maintenanceCost = this.vehicleInfo['maintenance']['costPerMile'] * Number(this.milesPerYear)
                    insuranceCost = this.vehicleInfo['insurance']['costPerMile'] * Number(this.milesPerYear)
                    taxesCost = this.vehicleInfo['taxes']['costPerMile'] * Number(this.milesPerYear)
                    tollsCost = this.vehicleInfo['tolls']['costPerMile'] * Number(this.milesPerYear)
                    driverCost = this.vehicleInfo['driver']['driverWagePerMile'] * Number(this.milesPerYear)
                    maintenanceCostHourly = this.vehicleInfo['maintenance']['costPerHour']
                    insuranceCostHourly = this.vehicleInfo['insurance']['costPerHour']
                    taxesCostHourly = this.vehicleInfo['taxes']['costPerHour']
                    tollsCostHourly = this.vehicleInfo['tolls']['costPerHour']
                    driverCostHourly = this.vehicleInfo['driver']['costPerHour']
                }

                // Set values based on storage item (Diesel)
                if (existingStorageOtherDiesel != null && existingStorageOtherDiesel.modified == true) {
                    maintenanceCostDiesel = Number(existingStorageOtherDiesel['cost-maintenance'])
                    insuranceCostDiesel = Number(existingStorageOtherDiesel['cost-insurance'])
                    taxesCostDiesel = Number(existingStorageOtherDiesel['cost-taxes'])
                    tollsCostDiesel = Number(existingStorageOtherDiesel['cost-tolls'])
                    driverCostDiesel = Number(existingStorageOtherDiesel['cost-driver'])
                    maintenanceCostHourlyDiesel = Number(existingStorageOtherDiesel['cost-maintenance-hourly'])
                    insuranceCostHourlyDiesel = Number(existingStorageOtherDiesel['cost-insurance-hourly'])
                    taxesCostHourlyDiesel = Number(existingStorageOtherDiesel['cost-taxes-hourly'])
                    tollsCostHourlyDiesel = Number(existingStorageOtherDiesel['cost-tolls-hourly'])
                    driverCostHourlyDiesel = Number(existingStorageOtherDiesel['cost-driver-hourly'])
                    modifiedDiesel = existingStorageOtherDiesel.modified
                } else {
                    maintenanceCostDiesel = globalDiesel['maintenance']['costPerMile'] * Number(this.milesPerYear)
                    insuranceCostDiesel = globalDiesel['insurance']['costPerMile'] * Number(this.milesPerYear)
                    taxesCostDiesel = globalDiesel['taxes']['costPerMile'] * Number(this.milesPerYear)
                    tollsCostDiesel = globalDiesel['tolls']['costPerMile'] * Number(this.milesPerYear)
                    driverCostDiesel = globalDiesel['driver']['driverWagePerMile'] * Number(this.milesPerYear)
                    maintenanceCostHourlyDiesel = globalDiesel['maintenance']['costPerHour']
                    insuranceCostHourlyDiesel = globalDiesel['insurance']['costPerHour']
                    taxesCostHourlyDiesel = globalDiesel['taxes']['costPerHour']
                    tollsCostHourlyDiesel = globalDiesel['tolls']['costPerHour']
                    driverCostHourlyDiesel = globalDiesel['driver']['costPerHour']
                }
                
                
                
                // calculate new totals
                let totalOtherCosts = Number(maintenanceCost) + Number(insuranceCost) + Number(taxesCost) + Number(tollsCost) + Number(driverCost)
                let totalOtherCostsDiesel = Number(maintenanceCostDiesel) + Number(insuranceCostDiesel) + Number(taxesCostDiesel) + Number(tollsCostDiesel) + Number(driverCostDiesel)
                let totalOtherCostsHourly = Number(maintenanceCostHourly) + Number(insuranceCostHourly) + Number(taxesCostHourly) + Number(tollsCostHourly) + Number(driverCostHourly)
                let totalOtherCostsHourlyDiesel = Number(maintenanceCostHourlyDiesel) + Number(insuranceCostHourlyDiesel) + Number(taxesCostHourlyDiesel) + Number(tollsCostHourlyDiesel) + Number(driverCostHourlyDiesel)
                
                let costPerMileOutputOther = Number(this.milesPerYear) === 0 ? 0 : totalOtherCosts / this.milesPerYear
                let costPerMileOutputOtherDiesel = Number(this.milesPerYear) === 0 ? 0 : totalOtherCostsDiesel / this.milesPerYear
                let costPerHourOutputOther = totalOtherCostsHourly * this.hoursPerYear
                let costPerHourOutputOtherDiesel = totalOtherCostsHourlyDiesel * this.hoursPerYear

                

                sessionStorage.setItem('electricOtherCost', JSON.stringify({
                        'annual-cost': Number((totalOtherCosts).toFixed(2)), 
                        'annual-cost-hourly': Number((costPerHourOutputOther).toFixed(2)), 
                        'cost-per-mile': Number((costPerMileOutputOther).toFixed(2)),
                        'cost-maintenance': Number((maintenanceCost).toFixed(2)),
                        'cost-insurance': Number((insuranceCost).toFixed(2)),
                        'cost-taxes': Number((taxesCost).toFixed(2)),
                        'cost-tolls': Number((tollsCost).toFixed(2)),
                        'cost-driver': Number((driverCost).toFixed(2)),
                        'cost-per-hour': Number((totalOtherCostsHourly).toFixed(2)),
                        'cost-maintenance-hourly': Number(maintenanceCostHourly),
                        'cost-insurance-hourly': Number(insuranceCostHourly),
                        'cost-taxes-hourly': Number(taxesCostHourly),
                        'cost-tolls-hourly': Number(tollsCostHourly),
                        'cost-driver-hourly': Number(driverCostHourly),
                        'modified': modifiedElectric
                    })
                )
                sessionStorage.setItem('dieselOtherCost', JSON.stringify({
                        'annual-cost': Number((totalOtherCostsDiesel).toFixed(2)), 
                        'annual-cost-hourly': Number((costPerHourOutputOtherDiesel).toFixed(2)), 
                        'cost-per-mile': Number((costPerMileOutputOtherDiesel).toFixed(2)),
                        'cost-maintenance': Number((maintenanceCostDiesel).toFixed(2)),
                        'cost-insurance': Number((insuranceCostDiesel).toFixed(2)),
                        'cost-taxes': Number((taxesCostDiesel).toFixed(2)),
                        'cost-tolls': Number((tollsCostDiesel).toFixed(2)),
                        'cost-driver': Number((driverCostDiesel).toFixed(2)),
                        'cost-per-hour': Number((totalOtherCostsHourlyDiesel).toFixed(2)),
                        'cost-maintenance-hourly': Number(maintenanceCostHourlyDiesel),
                        'cost-insurance-hourly': Number(insuranceCostHourlyDiesel),
                        'cost-taxes-hourly': Number(taxesCostHourlyDiesel),
                        'cost-tolls-hourly': Number(tollsCostHourlyDiesel),
                        'cost-driver-hourly': Number(driverCostHourlyDiesel),
                        'modified': modifiedDiesel
                    })
                )
                
                this.costElectric = JSON.parse(sessionStorage.getItem('electricFuelCost'))
                this.costEquipment = JSON.parse(sessionStorage.getItem('electricEquipmentCost'))
                this.costOther = JSON.parse(sessionStorage.getItem('electricOtherCost'))

                this.calculateDieselDefaults();
            },

            // madlad stuff. To account for the Diesel | Electric toggle, we actually have to do the default calculations for the other powertrain as well. Without it, the other powertrain page breaks unless they switch on the Fuel Costs view.
            calculateDieselDefaults() {
                let dieselVersion = JSON.parse(localStorage.getItem('calculatorVehicleDiesel'))

                // Fuel
                let annualCostOutput = this.milesPerYear == 0 ? 0 : parseFloat((dieselVersion['fuel']['mileage'] / dieselVersion['fuel']['milesPerGallon'] ) * dieselVersion['fuel']['fuelCostPerGallon']).toFixed(2)
                let annualCostOutputHourly = parseFloat(dieselVersion['fuel']['hours'] * 6.5 * dieselVersion['fuel']['fuelCostPerGallon']).toFixed(2)

                // Annual Cost / Mileage
                let costPerMileOutput = this.milesPerYear == 0 ? 0 : parseFloat(annualCostOutput / dieselVersion['fuel']['mileage']).toFixed(2)
                let costPerHourOutput = parseFloat(annualCostOutputHourly / dieselVersion['fuel']['hours']).toFixed(2)

                sessionStorage.setItem('dieselFuelCost', JSON.stringify({
                        'annual-cost': Number(annualCostOutput), 
                        'cost-per-mile': Number(costPerMileOutput),
                        'annual-cost-hourly': Number(annualCostOutputHourly), 
                        'cost-per-hour': Number(costPerHourOutput),
                        'mileage': Number(dieselVersion['fuel']['mileage']),
                        'hours': Number(dieselVersion['fuel']['hours'])
                    })
                )

                
                // Equipment
                let totalEquipmentCosts = (dieselVersion['equipment']['vehiclePrice'] - dieselVersion['equipment']['resaleValue'])  / dieselVersion['equipment']['amortization']
                let costPerMileOutputEquipment = totalEquipmentCosts / dieselVersion['fuel']['mileage']
                let costPerHourOutputEquipment = totalEquipmentCosts / dieselVersion['fuel']['hours']


                sessionStorage.setItem('dieselEquipmentCost', JSON.stringify({
                        'annual-cost': totalEquipmentCosts, 
                        'cost-per-mile': costPerMileOutputEquipment,
                        'cost-per-hour': costPerHourOutputEquipment
                    })
                )

                
                // Other
                let existingStorageOther = JSON.parse(sessionStorage.getItem('dieselOtherCost'))
                let maintenanceCost
                let insuranceCost
                let taxesCost
                let tollsCost
                let driverCost

                let maintenanceCostHourly
                let insuranceCostHourly
                let taxesCostHourly
                let tollsCostHourly
                let driverCostHourly
                let modified = true

                // Set values based on storage item
                if (existingStorageOther != null && existingStorageOther.modified == true) {
                    maintenanceCost = Number(existingStorageOther['cost-maintenance'])
                    insuranceCost = Number(existingStorageOther['cost-insurance'])
                    taxesCost = Number(existingStorageOther['cost-taxes'])
                    tollsCost = Number(existingStorageOther['cost-tolls'])
                    driverCost = Number(existingStorageOther['cost-driver'])

                    maintenanceCostHourly = Number(existingStorageOther['cost-maintenance-hourly'])
                    insuranceCostHourly = Number(existingStorageOther['cost-insurance-hourly'])
                    taxesCostHourly = Number(existingStorageOther['cost-taxes-hourly'])
                    tollsCostHourly = Number(existingStorageOther['cost-tolls-hourly'])
                    driverCostHourly = Number(existingStorageOther['cost-driver-hourly'])
                } else {
                    maintenanceCost = this.vehicleInfo['maintenance']['costPerMile'] * Number(this.milesPerYear)
                    insuranceCost = this.vehicleInfo['insurance']['costPerMile'] * Number(this.milesPerYear)
                    taxesCost = this.vehicleInfo['taxes']['costPerMile'] * Number(this.milesPerYear)
                    tollsCost = this.vehicleInfo['tolls']['costPerMile'] * Number(this.milesPerYear)
                    driverCost = this.vehicleInfo['driver']['driverWagePerMile'] * Number(this.milesPerYear)

                    maintenanceCostHourly = this.vehicleInfo['maintenance']['costPerHour']
                    insuranceCostHourly = this.vehicleInfo['insurance']['costPerHour']
                    taxesCostHourly = this.vehicleInfo['taxes']['costPerHour']
                    tollsCostHourly = this.vehicleInfo['tolls']['costPerHour']
                    driverCostHourly = this.vehicleInfo['driver']['costPerHour']
                    modified = false
                }
                
                // calculate new totals
                let totalOtherCosts = Number(maintenanceCost) + Number(insuranceCost) + Number(taxesCost) + Number(tollsCost) + Number(driverCost)
                let totalOtherCostsHourly = Number(maintenanceCostHourly) + Number(insuranceCostHourly) + Number(taxesCostHourly) + Number(tollsCostHourly) + Number(driverCostHourly)
                
                let costPerMileOutputOther = Number(this.milesPerYear) === 0 ? 0 : totalOtherCosts / this.milesPerYear
                let costPerHourOutputOther = totalOtherCostsHourly * this.hoursPerYear

                sessionStorage.setItem('dieselOtherCost', JSON.stringify({
                        'annual-cost': Number((totalOtherCosts).toFixed(2)), 
                        'annual-cost-hourly': Number((costPerHourOutputOther).toFixed(2)), 
                        'cost-per-mile': Number((costPerMileOutputOther).toFixed(2)),
                        'cost-maintenance': Number((maintenanceCost).toFixed(2)),
                        'cost-insurance': Number((insuranceCost).toFixed(2)),
                        'cost-taxes': Number((taxesCost).toFixed(2)),
                        'cost-tolls': Number((tollsCost).toFixed(2)),
                        'cost-driver': Number((driverCost).toFixed(2)),
                        'cost-per-hour': Number((totalOtherCostsHourly).toFixed(2)),
                        'cost-maintenance-hourly': Number(maintenanceCostHourly),
                        'cost-insurance-hourly': Number(insuranceCostHourly),
                        'cost-taxes-hourly': Number(taxesCostHourly),
                        'cost-tolls-hourly': Number(tollsCostHourly),
                        'cost-driver-hourly': Number(driverCostHourly),
                        'modified': modified
                    })
                )
            },

            //
            activeClickClear(removedElement, activeBodyType) {
                $(removedElement).removeClass('active');
                this.activeBodyType = activeBodyType
                sessionStorage.setItem('ElectricBodyType', JSON.stringify(activeBodyType))
                this.activeTab = activeBodyType.name

                setTimeout(() => {
                    let powerInputs = document.querySelectorAll('.power-consumption')
                    powerInputs.forEach(input => input.value = Number(input.value).toFixed(3) )
                }, 50)
            },

            clearActiveBody() {
                this.activeTab = 'none'
                this.activeBodyType = {}
            },

            // Sets Miles or Hours calculations based on selection in navigation
            setUsage(value) {
                (sessionStorage.getItem('usage') == null || sessionStorage.getItem('usage').length === 0) ? this.currentUsage = this.currentUsage : this.currentUsage = value
                this.calculateAllSetup()
            },
            
            // Formatting for inputs
            formatInputMiles() {
                this.milesPerYearFormatted = this.milesPerYearFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.milesPerYear = Number(this.milesPerYearFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderMiles() {
                this.milesPerYearFormatted = this.milesPerYear.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            formatInputHours() {
                this.hoursPerYearFormatted = this.hoursPerYearFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.hoursPerYear = Number(this.hoursPerYearFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderHours() {
                this.hoursPerYearFormatted = this.hoursPerYear.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            formatPrice(value, spaces = 2) {
                let val = (value/1).toFixed(spaces)
                if(isNaN(val)) {
                    return '$0.00'
                } else {
                    return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
            },
            updateMileage(value) { calculator.updateMileage(value) },
            updateHours(value) { calculator.updateHours(value) },
            trackNextCategory() {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Next Category',
                    'event_label': this.$route.path
                })
            },
            trackMilesPerYear(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Fuel Cost',
                    'event_label': 'Mileage ' + value
                })
            },
            trackHoursPerYear(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Fuel Cost',
                    'event_label': 'Operating Time ' + value
                })
            },
            trackElectricityCost(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Fuel Cost',
                    'event_label': 'Electricity Cost ' + value
                })
            },
            trackPTOPowerConsumption(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Fuel Cost',
                    'event_label': 'PTO Power Consumption ' + value
                })
            },
            trackPTOPowerConsumptionPerLift(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Fuel Cost',
                    'event_label': 'PTO Power Consumption Per Lift ' + value
                })
            },
            trackCollections(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Fuel Cost',
                    'event_label': 'Collections ' + value
                })
            },
            trackOperatingDays(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Fuel Cost',
                    'event_label': 'Operating Days Per Year ' + value
                })
            }
        }
    }
</script>

<style lang="scss">
    #vehicleDropdown {
        display: block;
        padding-left: 40px;
    }

    #vocation-select {
        text-decoration: none;
        word-break: break-word;
        white-space: pre-wrap;
        color: black;
        line-height: 2;
        border-bottom: #C00102 2px solid;
        margin-bottom: 0;
        display: inherit;
        //padding-right: 30px;
    }
    .dropdown-toggle {
        display: flex;
        align-items: center;
        position: relative;
        background-color: #ffffff;
        
        padding: 1rem 1.5rem;

        &:hover {
            text-decoration: none;
        }
    }
    .dropdown-toggle::after {
        position: absolute;
        top: 20%;
        right: 10px;
        color: #C00102;

        @media (min-width: 768px) {
            position: static;
            margin-left: auto;
        }
    }

    .dropdown-menu {
        width: 100%;
    }

    .dropdown-item.active, .dropdown-item:active {
        color: #fff;
        text-decoration: none;
        background-color: #C00102;
    }
    .tab-pane {
        .heading-3 {
            border-bottom: solid 2px #C00102;
            width: fit-content;
            padding-right: 2rem;
        }
    }
</style>